<div
  class="bg-gray-200 border-gray-300 border-2 border-dashed rounded ml-8"
  [ngStyle]="{ 'min-height.px': height }"
></div>
